<template>
  <div class="flex flex-col gap-6">
    <div v-if="initialLoading" class="flex flex-col items-center justify-center gap-2 mt-20">
      <CustomLoader :size="28" />
    </div>

    <EmptyScreen
        source="block_list"
        text="No emails/domains added to block list yet!"
        v-if="blockList?.length === 0 && !initialLoading"
    />

    <div v-else>
      <CustomTable
          v-if="blockList?.length > 0"
          :headers="headers"
          :data="blockList"
          prefixImageBorderRadius="0%"
          :custom-column-render="customColumnRender"
          @refresh="fetchBlockList"
      />
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import CustomTable from "@/src/components/custom_table_components/CustomTable.vue";
import CustomLoader from "@/src/components/CustomLoader.vue";
import EmptyScreen from "@/src/components/EmptyScreen.vue";
import BlockListActions from "@/src/components/block_list_components/BlockListActions.vue";
import DashboardService from "../../api/DashboardService.js";
import { emailDomainBlockListHeaders } from "@/src/constants/emailConstants.js";

const headers = emailDomainBlockListHeaders;

const customColumnRender = {
  actions: BlockListActions
};

const blockList = ref([]);
const initialLoading = ref(true);

const fetchBlockList = async (isInitial = false) => {
  if (isInitial) {
    initialLoading.value = true;
  }

  try {
    const response = await DashboardService.getEmailAndDomainBlocklists();
    if (response?.success) {
      blockList.value = response.blocklist.map(item => ({
        domain: item.value,
        added_on: new Date(item.created_at).toLocaleDateString('en-US', {
          day: '2-digit',
          month: 'short',
          year: 'numeric'
        }),
        id: item.id,
        type: item.type,
        value: item.value
      }));
    }
  } catch (error) {
    console.error("Error fetching block list:", error);
  } finally {
    if (isInitial) {
      initialLoading.value = false;
    }
  }
};

onMounted(() => {
  fetchBlockList(true);
});
</script>
